export const deleteChannelSuccess = {
  title: '更新完了',
};
